import { Box, Divider, Typography } from '@mui/material';

interface SidebarSectionTitleProps {
  name: string;
  isOpenedSidebar: boolean;
  isFirst?: boolean;
}

export const SidebarSectionTitle = ({ name, isOpenedSidebar, isFirst = false }: SidebarSectionTitleProps) => {
  return (
    <Box
      sx={{
        mt: isFirst ? 1 : 1.25,
        mb: 0.5,
        height: 28,
        px: isOpenedSidebar ? 0.75 : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: isOpenedSidebar ? 1.5 : 0,
        transition: 'padding 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <Divider
        sx={{
          flexGrow: isOpenedSidebar ? 1 : 0,
          width: isOpenedSidebar ? 'auto' : '30%',
          borderColor: isOpenedSidebar ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.15)',
          transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          color: '#8c9ead',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          opacity: isOpenedSidebar ? 1 : 0,
          visibility: isOpenedSidebar ? 'visible' : 'hidden',
          width: isOpenedSidebar ? 'auto' : 0,
          overflow: 'hidden',
          transition: 'opacity 0.3s ease',
        }}
      >
        {name}
      </Typography>
      <Divider
        sx={{
          flexGrow: isOpenedSidebar ? 1 : 0,
          width: isOpenedSidebar ? 'auto' : '30%',
          borderColor: isOpenedSidebar ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.15)',
          transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
    </Box>
  );
};
